export const mealTypeObj = {
  1: "单品",
  2: "套餐"
}
export const mealTypeOptions = Object.keys(mealTypeObj).map(val => {
  return {
    label: mealTypeObj[val],
    value: val
  }
})